import { render, staticRenderFns } from "./simple_form.vue?vue&type=template&id=206fba16&scoped=true&"
import script from "./simple_form.vue?vue&type=script&lang=js&"
export * from "./simple_form.vue?vue&type=script&lang=js&"
import style0 from "./simple_form.vue?vue&type=style&index=0&id=206fba16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fba16",
  null
  
)

export default component.exports